<template>
  <div>
    <entrepot-docs-list-desktop-bridge v-if="isDesktopListLayout" />
    <entrepot-docs-list-mobile v-else />
    <entrepot-doc-print ref="entrepotDocPrint" :type="type" @error="serverErrorHandeler" />
    <accounting-doc-view
      v-model="docView.open"
      :item="docView.item"
      @edit="openDocEdit"
      @error="serverErrorHandeler"
    />
    <!--    filter dialog-->
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ entrepotDocsFilterTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-warehouse</v-icon>
              {{ $t("entrepotFilterMain") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="product"
                type="product"
                :title="$t('product')"
                :outlined="true"
              />
              <autocomplete
                v-model="entrepot"
                title="entrepot"
                type="entrepot"
                :filter="true"
                :multiple="true"
              />
              <status v-model="sellStatus" :hideconfig="true" />
              <tag v-model="tag" />
              <v-select
                v-model="statusControll"
                :label="$t('statusControll')"
                :items="statusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-clock-outline</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromTime"
                  v-model="fromTime"
                  :label="$t('from-hour')"
                  prepend-inner-icon="mdi-clock-start"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="fromTime"
                  element="fromTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toTime"
                  v-model="toTime"
                  :label="$t('to-hour')"
                  prepend-inner-icon="mdi-clock-end"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="toTime"
                  element="toTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="lockStatus"
                :label="$t('lockStatusDocuments')"
                :items="lockStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
<v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print :headerProp="headers_v" :itemsProp="items" :title="$t('cashPayList')" />
        </v-row>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload doalog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            :type-prop="type === 'warehouseHandling' ? 'warehouseHandling' : 'entrepot'"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <export-excel
      v-show="false"
      ref="rowExcelRef"
      :data="rowExcelItems"
      worksheet="abriron.com"
      :name="rowExcelFileName"
      type="xls"
      :title="$store.state.abrName"
      :total-prop="1"
      :page-prop="1"
      :excelIndex="true"
    />
    <snakbar v-model="snakbar" :text="snakbarText" :active="snakbar" />
  </div>
</template>

<script>
import Vue from "vue";
import EntrepotDocPrint from "./layouts/EntrepotDocPrint.vue";
import AccountingDocView from "@/views/dashboard/pages/accounting/layouts/AccountingDocView.vue";

import Task from "../task/task";
import General from "../../../../Mixins/general";
import Print from "../../components/general/Print/Index";
import Upload from "../../components/general/upload/upload";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import EntrepotDocsListDesktopBridge from "./layouts/desktop/EntrepotDocsListDesktopBridge.vue";
import EntrepotDocsListMobile from "./layouts/mobile/EntrepotDocsListMobile.vue";
import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";
export default {
  name: "entrepotList",
  provide() {
    return { entrepotDocsList: this };
  },
  components: {
    EntrepotDocPrint,
    AccountingDocView,
    ProListFrame,
    PrintStudio,
    EntrepotDocsListDesktopBridge,
    EntrepotDocsListMobile,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    Upload,
    Task,
    Print,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "mobileShow"],
  data: () => ({
    excelItems: [],
    rowExcelItems: [],
    rowExcelFileName: "entrepot-data.xls",
    statusItems: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    deletDialog: false,
    uploadDialog: false,
    filter: false,
    product: null,
    entrepot: null,
    statusControll: null,
    model: null,
    from: 1,
    taskDialog: null,
    type: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    // Separate from General mixin money `options` (beforeMount overwrites it).
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: null,
    search: null,
    fromTime: null,
    toTime: null,
    printItems: [],
    printType: "entrepot",
  }),
  // UI-only state outside data() (list payloads must stay clean).
  created() {
    this.docView = Vue.observable({ open: false, item: null });
  },
  computed: {

    entrepotDocsFilterTitle() {
      var map = {
        receiptList: "receiptFilterTitle",
        tempReceiptList: "tempReceiptFilterTitle",
        remittanceList: "remittanceFilterTitle",
        useRemittanceList: "useRemittanceFilterTitle",
        transferRemittanceList: "transferRemittanceFilterTitle",
        warehouseHandlingList: "warehouseHandlingFilterTitle",
        transferProductStockList: "transferProductStockFilterTitle",
      };
      var key = map[this.$route.name] || "entrepotDocsFilterTitle";
      return this.$t(key);
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };
      var defs = [
        ["product", app.$t("product")],
        ["entrepot", app.$t("entrepot")],
        ["sellStatus", app.$t("status")],
        ["tag", app.$t("tag")],
        ["statusControll", app.$t("statusControll"), pick(app.statusItems, app.statusControll)],
        ["fromTime", app.$t("from-hour")],
        ["toTime", app.$t("to-hour")],
        ["branch", app.$t("branch")],
        ["lockStatus", app.$t("lockStatusDocuments"), pick(app.lockStatusItems, app.lockStatus)],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    // Shipping label only for documents that leave the warehouse.
    canLabelPrint() {
      return ["remittance", "useRemittance", "transferRemittance"].indexOf(this.type) > -1;
    },
    proListKey() {
      return this.entrepotListColumnPersistKey;
    },
    proListLocked() {
      return this.entrepotListLockedColumns;
    },
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isDesktopListLayout() {
      if (this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    entrepotListColumnPersistKey() {
      return "entrepot-list-table-columns-" + (this.type || "tempReceipt");
    },
    entrepotListLockedColumns() {
      // Fixed sticky block: select + actions + id + doc number (no unpin/drag)
      var locked = ["actions", "id", "doc_header.number"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    entrepotListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.entrepotListLockedColumns,
        anchor: "doc_header.number",
        minWidth: 60,
        persistKey: this.entrepotListColumnPersistKey,
      };
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      this.model = this.selected[0].text;
      this.temp = this.selected[0].text;
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        const sortBy = (app.tableOptions && app.tableOptions.sortBy) || [];
        sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          if (index > -1 && app.headers[index].table) {
            app.sortBy.push(app.headers[index].table);
          }
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  beforeMount() {
    this.type = this.$route.name;
    if (this.$route.name === "tempReceiptList") {
      this.type = "tempReceipt";
    }
    if (this.$route.name === "receiptList") {
      this.type = "receipt";
    }
    if (this.$route.name === "remittanceList") {
      this.type = "remittance";
    }
    if (this.$route.name === "useRemittanceList") {
      this.type = "useRemittance";
    }
    if (this.$route.name === "transferRemittanceList") {
      this.type = "transferRemittance";
    }
    if (this.$route.name === "warehouseHandlingList") {
      this.type = "warehouseHandling";
    }
    if (this.$route.name === "transferProductStockList") {
      this.type = "transferProductStock";
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("id"),
        sortable: false,
        value: "id",
      },
      {
        text: this.$t("document-number"),
        sortable: true,
        value: "doc_header.number",
      },
      //condition for show these column
      ...(this.$route.name === "transferRemittanceList"
        ? [
            {
              text: this.$t("type"),
              sortable: false,
              value: "type",
            },
          ]
        : []),
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.name",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      //condition for show these column
      ...(this.$route.name === "transferRemittanceList"
        ? [
            {
              text: this.$t("recipientEntrepot"),
              sortable: false,
              value: "recipient_entrepot.name",
            },
            {
              text: this.$t("recipientBranch"),
              sortable: false,
              value: "recipientBranch.name",
            },
          ]
        : []),
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "entrepot_head.date",
      },
      {
        text: this.$t("statusControll"),
        sortable: true,
        value: "status",
        table: "entrepot_head.status",
      },
      {
        text: this.$t("relation-whit"),
        sortable: false,
        value: "invoice",
      },
      {
        text: this.$t("status"),
        sortable: true,
        value: "last_status.status_id",
        width: 50,
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("description"),
        sortable: true,
        value: "content",
        table: "payments.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.headers_v = [
      // {
      //   text: this.$t("actions"),
      //   align: "start",
      //   sortable: false,
      //   value: "actions",
      //   width: 20,
      // },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: false,
        value: "id",
      },
      {
        text: this.$t("document-number"),
        sortable: true,
        value: "doc_header.number",
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.name",
      },
      {
        text: this.$t("recipientEntrepot"),
        sortable: false,
        value: "recipient_entrepot.name",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "entrepot_head.date",
      },
      // {
      //   text: this.$t("statusControll"),
      //   sortable: true,
      //   value: "status",
      //   table: "entrepot_head.status",
      // },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      // {
      //   text: this.$t("relation-whit"),
      //   sortable: false,
      //   value: "invoice",
      // },
      // {
      //   text: this.$t("status"),
      //   sortable: true,
      //   value: "last_status.status_id",
      //   width: 50,
      // },
      // {
      //   text: this.$t("tag"),
      //   sortable: false,
      //   value: "tags",
      // },
      {
        text: this.$t("description"),
        sortable: true,
        value: "content",
        table: "payments.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    reorderPinnedHeaders(this.headers, {
      locked: this.entrepotListLockedColumns,
      anchor: "doc_header.number",
    });
    this.loadEntrepotListColumnSettings();
    this.statusItems = [
      {
        value: "LeavingTheWarehouse",
        text: this.$t("LeavingTheWarehouse"),
      },
      {
        value: "LogInWarehouse",
        text: this.$t("LogInWarehouse"),
      },
      {
        value: "storekeeperCountError",
        text: this.$t("storekeeperCountError"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
  },
  mounted() {
    // this.getItems()
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "product", "entrepot", "sellStatus", "tag", "statusControll",
        "fromTime", "toTime", "branch", "lockStatus",
      ].forEach(function (k) {
        app[k] = null;
      });
    },

    loadEntrepotListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.entrepotListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.entrepotListLockedColumns,
          anchor: "doc_header.number",
        });
        app.$forceUpdate();
      });
    },
    printExecution(id) {
      var app = this;
      app.printItems.push(id);

      app.loading = true;
      app.$axios
        .get(app.$endpoint + "entrepot", {
          params: {
            print: "active",
            id: app.printItems,
            type: app.printType,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({
            name: "reportViewer",
            params: { dataProp: res, reportProp: app.printType },
          });
          app.printItems = [];
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    openUploadDialog(item) {
      if (!this.$root) {
        return;
      }
      const type =
        this.type === "warehouseHandling" ? "warehouseHandling" : "entrepot";
      this.$root.$emit("open-user-file-process", { type });
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
    },
    checkout(item) {
      if (item.lock) {
        return false;
      }
      this.$router.push({ name: this.type + "Checkout", params: { id: item.id } });
    },
    // Print through the print module (single row or group in list order).
    // mode: "doc" (the document) | "label" (shipping label).
    print(item, mode, picked) {
      var list = item ? [item] : (picked || this.selected || []).slice();
      if (!list.length) return;
      var order = this.items || [];
      var pos = function (x) {
        var i = order.findIndex(function (r) { return r.id === x.id; });
        return i < 0 ? Number.MAX_SAFE_INTEGER : i;
      };
      list.sort(function (a, b) { return pos(a) - pos(b); });
      this.$refs.entrepotDocPrint.open(list, mode || "doc");
    },
    labelPrint(item, picked) {
      this.print(item, "label", picked);
    },
    // View the linked accounting document (same dialog as the accounting list).
    viewDocument(item) {
      var id = item && (item.doc_head_id || (item.doc_header && item.doc_header.id));
      if (!id) return;
      this.docView.item = { id: id, lock: item.lock };
      this.docView.open = true;
    },
    openDocEdit(doc) {
      this.docView.open = false;
      this.$router.push({ name: "accountingEdit", params: { id: doc.id } });
    },

    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            search: app.search,
            lockStatus: app.lockStatus,
            page: app.allRows ? app.excelPage : ((app.tableOptions && app.tableOptions.page) || 1),
            product: app.product,
            entrepot: app.entrepot,
            refId: app.refId,
            branch: app.branch,
            type: app.type,
            sortBy: app.sortBy,
            options: app.tableOptions,
            tag: app.tag,
            status: app.sellStatus,
            statusControll: app.statusControll,
            fromTime: app.fromTime,
            toTime: app.toTime,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    copyToInvoice(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "entrepot/" + item.id + "/edit", {
          params: {
            id: item.id,
          },
        })
        .then((res) => {
          res = res.data;
          var items = [];
          res.articles.map(function (value) {
            items.push({
              product: value.product,
              count: value.count,
              countEdit: 0,
              fee: null,
              discount: 0,
              discountPercent: 0,
              tax: 0,
              unit: null,
              content: 0,
            });
          });
          app.$router.push({ name: "sell", params: { itemsProp: items } });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "entrepot/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            deleteItems: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          date: d.date,
          type: app.$t(d.type),
          entrepot: d.entrepot ? d.entrepot.name : "",
          docHeader: d.doc_header ? d.doc_header.number : "",
          invoice: d.invoice ? d.invoice.type + " | " + d.invoice.id : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    //create excel for each item
    exportRowExcel(item) {
      var app = this;
      app.rowExcelFileName = "entrepot-" + item.id + ".xls";
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "entrepot/" + item.id + "/edit", {
          params: {
            id: item.id,
          },
        })
        .then((res) => {
          app.creatArticlesExcelData(res.data.articles);
          app.$nextTick(() => {
            if (app.rowExcelItems.length && app.$refs.rowExcelRef) {
              app.$refs.rowExcelRef.generate();
            }
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    creatArticlesExcelData(data) {
      var app = this;
      app.rowExcelItems = [];
      data.map(function (d) {
        app.rowExcelItems.push({
          id: d.id,
          productName: d.product.name,
          stock:
            d.product && d.product.stock
              ? app.$numberFormat(d.product.stock.count, 3)
              : 0,
          counting_one: d.counting_one ? d.counting_one : "",
          counting_two: d.counting_two ? d.counting_two : "",
          counting_final: d.count ? d.count : "",
          Stock_shortage_or_excess_in_warehouse: app.resolveWarehouseStock(d),
          price: d.price ? app.$numberFormat(d.price) : "",
          expireDate: d.expire_date ? d.expire_date : "",
          content: d.content ? d.content : "",
          entrepot: d.entrepot ? d.entrepot.name : "",
        });
      });
    },
    resolveWarehouseStock(item) {
      if (item.product.stock.count) {
        if (item.count != null) {
          return Number(item.product.stock.count) - Number(item.count);
        } else if (item.counting_two != null) {
          return Number(item.product.stock.count) - Number(item.counting_two);
        } else if (item.counting_one != null) {
          return Number(item.product.stock.count) - Number(item.counting_one);
        }
      } else {
        return Number(item.product.stock.count);
      }
    },
  },
};

</script>

<style scoped lang="scss">
/* Desktop chrome: shared pro-list kit (slot content of ProListFrame) */
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
/* Desktop list viewport (parity with invoice list): page chrome stays fixed; only table body scrolls */
.entrepot-list-page--fixed {
  height: calc(100vh - 98px) !important;
  max-height: calc(100vh - 98px);
  padding-bottom: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.entrepot-list-page--fixed .entrepot-list-toolbar {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-toolbar__content {
  height: 40px !important;
  max-height: none !important;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow: visible;
  width: 100%;
  margin-top: 3px;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-inline-end: 0 !important;
}
.entrepot-list-page--fixed .entrepot-list-toolbar.v-toolbar,
.entrepot-list-page--fixed .entrepot-list-toolbar.v-app-bar {
  margin-bottom: 0 !important;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-btn {
  height: 28px !important;
  min-height: 28px !important;
  margin-top: 5px !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-btn .v-btn__content {
  align-items: center;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-btn .v-btn__content p {
  font-size: 11px;
  line-height: 1;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-btn .v-icon {
  font-size: 18px !important;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .float-left {
  float: none !important;
  display: inline-flex;
  align-items: center;
}
.entrepot-list-page--fixed .entrepot-list-toolbar__search {
  display: flex;
  align-items: flex-start;
  margin-top: 0;
}
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .entrepot-list-toolbar__search .v-text-field {
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 0;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-text-field--outlined.v-input--dense
  .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  align-items: center !important;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-input__append-inner,
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-input__prepend-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-self: stretch !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 32px !important;
  max-height: 32px !important;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-input__icon {
  height: 32px !important;
  min-height: 32px !important;
  width: 24px !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-input__icon
  .v-icon {
  height: 20px !important;
  width: 20px !important;
  font-size: 20px !important;
  line-height: 1 !important;
  margin: 0 !important;
  transform: translateY(2px);
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-text-field--outlined
  fieldset {
  top: 0;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-text-field--outlined.v-input--dense
  .v-label {
  top: 6px;
}
.entrepot-list-page--fixed
  .entrepot-list-toolbar
  ::v-deep
  .entrepot-list-toolbar__search
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  .v-label--active {
  transform: translateY(-14px) scale(0.75);
}
/* Keep title size like invoice list (Vuetify default ~1.25rem), not dense-shrunk */
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .entrepot-list-toolbar__title,
.entrepot-list-page--fixed .entrepot-list-toolbar ::v-deep .v-toolbar__title {
  font-size: 1.25rem !important;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 2px !important;
  margin-bottom: 0 !important;
  align-self: center;
}
.entrepot-list-page--fixed .entrepot-list-table-col {
  flex: 1 1 auto !important;
  flex-grow: 1 !important;
  flex-shrink: 1 !important;
  min-height: 0 !important;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}
.entrepot-list-page--fixed .entrepot-list-table {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 5px;
}
.entrepot-list-page--fixed ::v-deep .entrepot-list-table > .v-data-table__wrapper {
  flex: 1 1 auto;
  min-height: 0;
  border-top: 1px solid #eeeeee;
  position: relative;
  z-index: 0;
  isolation: isolate;
}
.entrepot-list-page--fixed ::v-deep .entrepot-list-table > .v-data-footer {
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  min-height: unset;
  height: auto;
  padding: 0 !important;
  margin: 0;
  border-top: none;
  background: rgba(255, 255, 255, 0.42);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
  font-size: 12px !important;
}
.entrepot-list-page--fixed ::v-deep .entrepot-list-table > .v-data-footer > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  min-height: 43px !important;
  height: 43px !important;
  display: flex !important;
  align-items: center !important;
}
.entrepot-list-page--fixed ::v-deep .entrepot-list-table > .v-data-footer > .v-col {
  padding-inline: 10px !important;
  max-width: none;
  display: flex !important;
  align-items: center !important;
}
.entrepot-list-goto-page {
  margin-right: 12px !important;
}
/* Desktop: col stays footer-height; glass chip inside is compact */
.entrepot-list-goto-page--compact {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  transform: none;
  /* RTL end (left): next to pagination icons */
  order: 4;
  margin-inline-start: auto !important;
}
.entrepot-list-goto-page__box {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  line-height: 1;
  min-height: 0;
  width: auto;
  box-sizing: border-box;
}
.entrepot-list-goto-page__label {
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 24px;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.62);
}
/* Keep nested Vuetify field transparent so the box bg shows through */
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field,
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field.v-text-field,
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field .v-input,
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field .v-input__control,
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field {
  width: 52px;
  flex: 0 0 52px;
}
.entrepot-list-goto-page--compact
  ::v-deep
  .entrepot-list-goto-page__field.v-text-field--solo
  .v-input__slot {
  margin: 0 !important;
  align-items: center !important;
}
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field fieldset {
  display: none !important;
}
.entrepot-list-goto-page--compact ::v-deep .entrepot-list-goto-page__field input {
  font-size: 11px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  max-height: 20px;
  line-height: 20px;
  text-align: center;
  background: transparent !important;
}
.entrepot-list-goto-page--compact
  ::v-deep
  .entrepot-list-goto-page__field
  .v-text-field__suffix {
  align-self: center !important;
  line-height: 20px !important;
  font-size: 11px;
  margin: 0 !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  height: 24px !important;
  min-height: 24px !important;
  align-self: center !important;
  padding: 0 8px !important;
  margin-inline: 4px !important;
  border-radius: 4px;
  background: rgba(120, 130, 140, 0.12) !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 11px !important;
  line-height: 1;
  color: rgba(0, 0, 0, 0.62);
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select {
  order: 1;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  order: 2;
  margin-inline-start: 4px !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-before {
  order: 5;
  margin-inline-start: 4px !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-after {
  order: 6;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selection,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selections,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-label,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__pagination {
  color: rgba(0, 0, 0, 0.62) !important;
  font-size: 11px !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot::before,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot::after {
  display: none !important;
  border: none !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-before,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-after {
  height: 24px !important;
  min-height: 24px !important;
  align-self: center !important;
  padding: 0 4px !important;
  margin-inline: 4px !important;
  border-radius: 4px;
  background: rgba(120, 130, 140, 0.12) !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 12px !important;
  line-height: 1;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-before
  .v-btn,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-after
  .v-btn {
  width: 22px !important;
  height: 22px !important;
  margin: 0 1px !important;
  color: rgba(55, 71, 79, 0.78) !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-before
  .v-btn
  .v-icon,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__icons-after
  .v-btn
  .v-icon {
  font-size: 16px !important;
  color: inherit !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 11px;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__control {
  min-height: 20px !important;
  height: 20px !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__slot {
  margin-bottom: 0 !important;
  min-height: 20px !important;
  height: 20px !important;
  align-items: center !important;
  background: transparent !important;
  box-shadow: none !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-select__selections {
  font-size: 11px;
  min-height: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  align-items: center;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-input__icon,
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  > .v-data-footer__select
  .v-icon {
  height: 18px !important;
  min-width: 18px !important;
  font-size: 14px !important;
  color: rgba(55, 71, 79, 0.7) !important;
}
.entrepot-list-page--fixed ::v-deep .entrepot-list-table > .v-data-footer .v-btn {
  width: 28px !important;
  height: 28px !important;
  margin: 0 2px !important;
  align-self: center !important;
}
.entrepot-list-page--fixed
  ::v-deep
  .entrepot-list-table
  > .v-data-footer
  .v-btn
  .v-icon {
  font-size: 18px !important;
}
/* Dense table (parity with invoice list): header / rows / zebra */
.entrepot-list-table.main-table.v-data-table--fixed-header
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr:not(.v-data-table__progress)
  > th {
  z-index: 2;
  box-shadow: 0 1px 0 #eeeeee;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr.v-data-table__progress {
  position: sticky;
  top: 28px;
  z-index: 20;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr.v-data-table__progress
  > th {
  position: relative !important;
  top: auto !important;
  height: 0 !important;
  min-height: 0 !important;
  max-height: none !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  overflow: visible !important;
  z-index: 20 !important;
}
.entrepot-list-table--dense ::v-deep > .v-data-table__wrapper > table {
  border-collapse: separate;
  border-spacing: 0;
}
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr:not(.v-data-table__progress)
  > th {
  height: 28px !important;
  padding: 0 6px !important;
  font-size: 8.5pt !important;
  font-weight: 600;
  white-space: nowrap;
  background-color: #fff !important;
  border-left: 1px solid #eeeeee !important;
  box-shadow: 0 1px 0 #eeeeee !important;
}
.entrepot-list-table--dense ::v-deep > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid #eeeeee !important;
  border-bottom: 1px solid #f3f3f3 !important;
}
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child,
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  border-left: none !important;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd)
  > td {
  background-color: #f5f5f5 !important;
  background-image: none !important;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even)
  > td {
  background-color: #fff !important;
  background-image: none !important;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover
  > td {
  background-color: #eee !important;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected
  > td {
  background-color: #eeeeee !important;
}
.entrepot-list-table--dense.main-table
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__selected:hover
  > td {
  background-color: #e0e0e0 !important;
}
.entrepot-list-table--dense.main-table.v-data-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr,
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  height: 40px !important;
  max-height: 40px !important;
}
.entrepot-list-table--dense.main-table.v-data-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.entrepot-list-table--dense ::v-deep > .v-data-table__wrapper > table > tbody > tr > td {
  height: 40px !important;
  max-height: 40px !important;
  min-height: 40px !important;
  padding: 2px 6px !important;
  font-size: 11px;
  vertical-align: middle !important;
  overflow: hidden;
  line-height: 1.25;
}
.entrepot-list-table--dense ::v-deep .text-caption,
.entrepot-list-table--dense ::v-deep .v-card__text.text-caption {
  font-size: 10px !important;
  line-height: 1.25 !important;
}
.entrepot-list-table--dense ::v-deep .v-chip.v-size--small {
  height: 20px !important;
  font-size: 10px !important;
  margin: 1px 0 !important;
}
.entrepot-list-table--dense ::v-deep .v-btn--icon.v-size--small,
.entrepot-list-table--dense ::v-deep .v-btn--icon.v-size--default {
  width: 28px !important;
  height: 28px !important;
}
.entrepot-list-table--dense ::v-deep .v-icon {
  font-size: 18px !important;
}
/* Column plugin chrome (pin / drag) in dense header */
.entrepot-list-table--dense ::v-deep .column-pin-btn {
  width: 16px;
  height: 16px;
  margin-inline-end: 2px;
}
.entrepot-list-table--dense ::v-deep .column-pin-btn .mdi {
  font-size: 12px;
}
.entrepot-list-table--dense ::v-deep .column-drag-btn {
  opacity: 0.7;
}
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th[data-col="__select"],
.entrepot-list-table--dense
  ::v-deep
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td[data-col="__select"] {
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 0 !important;
  text-align: center !important;
}
.entrepot-list-table--dense ::v-deep td[data-col="__select"] .v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
  justify-content: center;
}
.entrepot-list-table--dense
  ::v-deep
  td[data-col="__select"]
  .v-input--selection-controls__input,
.entrepot-list-table--dense
  ::v-deep
  th[data-col="__select"]
  .v-input--selection-controls__input {
  margin: 0 !important;
  width: 18px !important;
  height: 18px !important;
}
</style>
